const NativeApi = {
  ctx: null,
  init(ctx) {
    this.ctx = ctx;
  },

  lastBack: 0,

  onNativeCall(msg) {
    this.ctx.$logger.log("onNativeCall " + JSON.stringify(msg))
    if (msg == null) {
      return;
    }
    let self = this
    var successCB = null, errorCB = null;
    if (msg.hasOwnProperty("rpcId")) {
      var mqCB = client.rpcCB[msg.rpcId];
      if (mqCB != null) {
        successCB = mqCB.successCB;
        errorCB = mqCB.errorCB;

        if (msg.rpcId in client.rpcCB) {
          delete client.rpcCB[msg.rpcId];
        }
      }
    }

    if (msg.cmd == "ready") {
      client.clientReady = true
      this.parseClient(msg.client);
    } else if (msg.cmd == "client") {
      this.parseClient(msg)
      this.ctx.$login_data.tokenLogin()
    } else if (msg.cmd == "location") {
      this.parseLocation(msg)
    } else if (msg.cmd == "share") {
      this.parseShare(msg)
    } else if (msg.cmd == "auth") {
      this.parseAuth(msg)
    } else if (msg.cmd == "io") {

    } else if (msg.cmd == "networkinfo") {

    } else if (msg.cmd == 'charge') {
      this.ctx.$nav_util.goHome()
      this.ctx.$http_data.infoGet(function (data) {
        self.ctx.$info.parse(data)
      })
    }else if(msg.cmd == 'app'){
      if(msg.method == 'back'){
        let len = this.ctx.$children.length
        if(this.ctx.$children[len-1].isHome || (!this.ctx.$info.loginOK && this.ctx.$children[len-1].isLogin)){
          let now = new Date().getTime()
          if(now - this.lastBack <= 1500){
            onJsCall({cmd: 'app', method:'finish'})
          }else{
            this.ctx.$nav_util.showToastNormal("再按一次退出友一圈")
          }
          this.lastBack = now;
        }else{
          this.ctx.$nav_util.goBack();
        }
      }
    }
    this.onMQCallback(msg, successCB, errorCB)
    this.parseTmpCallback(msg)
  },

  onMQCallback(obj, successCB, errorCB) {
    if (obj.hasOwnProperty("error")) {
      if (errorCB != null) {
        errorCB(obj)
      }
    } else {
      if (successCB != null) {
        successCB(obj)
      }
    }
  },
  tmpCallback : {},
  parseTmpCallback(msg){
    console.log("xxx ", msg)
    try{
      for (let key in this.tmpCallback) {
        if(msg.hasOwnProperty(key)){
          this.tmpCallback[key](msg)
        }
        delete this.tmpCallback[key]
      }
    }catch (e) {
      console.error(e)
    }
  },
  parseClient(obj) {
    this.ctx.$device.deviceCode = obj.imei
    this.ctx.$device.deviceType = obj.system
    this.ctx.$device.deviceInfo = obj.model
    this.ctx.$device.deviceChannel = obj.channel
    this.ctx.$device.version = obj.version
  },
  parseLocation(obj) {
    if (obj.hasOwnProperty('lat') && obj.hasOwnProperty('lng') && obj.lat != 0 && obj.lng != 0) {
      this.ctx.$info.location.lat = obj.lat
      this.ctx.$info.location.lng = obj.lng
      this.ctx.$info.location.accuracy = obj.accuracy
      this.ctx.$info.location.city = obj.city.city
      this.ctx.$info.location.addr = obj.city.addr
    } else {
      this.ctx.$nav_util.showToastNormal('位置获取失败')
    }
  },

  parseAuth(obj){
    if(obj.code){
      let self = this;

      this.ctx.$http_data.loginAppWechat(obj.code, function (data) {
        self.ctx.$login_data.onLoginSuccess(data);
        self.ctx.$nav_util.goHome()
      })
    }else{
      this.ctx.$nav_util.showToastNormal("微信授权失败")
    }

  },

  isIosCheck(){
    return iosChecking()
  },

  parseShare(obj){
    console.error(obj)
  },

  locGettedPoint: null,
  /*获取浏览器经纬度*/
  getLocation(successFunc, errorFunc) { //successFunc获取定位成功回调函数，errorFunc获取定位失败回调
    let self = this

    if (client.isClient) {
      onJsCall({cmd: 'location'}, successFunc)
    } else {
      if(self.locGettedPoint != null){
        locationSuccess(self.locGettedPoint);
        return ;
      }
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          let point = r.point
          locationSuccess(point)
          let gc = new BMap.Geocoder();
          gc.getLocation(point, function (rs) {
            var addComp = rs.addressComponents;
            if(addComp && addComp.city){
              self.ctx.$info.location.city = addComp.city

              self.locGettedPoint = point;
            }
          });
        } else {
          locationError(r)
        }
      }, {enableHighAccuracy: true, timeout: 5000})

      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(locationSuccess, locationError, {
      //     enableHighAccuracy: true,
      //     timeout: 5000,
      //     maximumAge: 3000
      //   });
      // } else {
      //   self.ctx.$store.commit('showToastNormal', '设备不支持')
      // }
    }

    function locationSuccess(point) {
      if(point.lat != 0 && point.lng != 0){
        self.lat = point.lat;
        self.lng = point.lng;

        self.ctx.$info.location.lat = self.lat
        self.ctx.$info.location.lng = self.lng

        if (successFunc) {
          successFunc()
        }
      }else{
        locationError()
      }
    }

    function locationError(e) {
      console.error('位置获取失败', e)
      if (errorFunc) {
        errorFunc()
      }
      // switch (e.code) {
      //   case e.TIMEOUT:
      //     self.ctx.$store.commit('showToastNormal', '请求用户位置超时')
      //     break;
      //   case e.PERMISSION_DENIED:
      //     self.ctx.$store.commit('showToastNormal', '您拒绝了位置服务！')
      //     break;
      //   case e.POSITION_UNAVAILABLE:
      //     self.ctx.$store.commit('showToastNormal', '发生一个位置错误')
      //     break;
      // }
    }
  }
}

NativeApi.install = function (Vue, options) {
  Vue.prototype.$native = NativeApi
}

export default NativeApi;


// bdLocation: null,
// getWebLocation() {
//   this.bdLocation = new BMap.Geolocation()
//   this.bdLocation.getCurrentPosition(function (r) {
//     // alert(this.getStatus())
//     alert(r)
//     alert(r.point.lng)
//     console.log(r.point)
//     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
//       // var mk = new BMap.Marker(r.point);
//       // map.addOverlay(mk);//标出所在地
//       // map.panTo(r.point);//地图中心移动
//       // //alert('您的位置：'+r.point.lng+','+r.point.lat);
//       // lng = r.point.lng;
//       // lat = r.point.lat;
//       // var point = new BMap.Point(r.point.lng, r.point.lat);    //用所定位的经纬度查找所在地省市街道等信息
//       // var gc = new BMap.Geocoder();
//       // gc.getLocation(point, function (rs) {
//       //   var addComp = rs.addressComponents;
//       //   console.log(rs.address);//地址信息
//       //   //myKeys = [rs.address];     当有其他信息时，可以定义成数组
//       //   myKeys = rs.address;
//       //   //alert(myKeys);         //弹出所在地址
//       //   var local = new BMap.LocalSearch(map, {
//       //     renderOptions: {map: map, panel: "r-result"},
//       //     pageCapacity: 3
//       //   });
//       //   local.searchInBounds(myKeys, map.getBounds());
//       // });
//       alert(r.point.lng)
//     } else {
//       alert('failed' + this.getStatus());
//
//     }
//   }, {enableHighAccuracy: true})
// },



// WEBPACK FOOTER //
// ./src/plugins/native-api.js